// extracted by mini-css-extract-plugin
module.exports = {"richText":"RawHtml_richText__UpgAV","table":"RawHtml_table__ttJdw"};